import React from 'react'
import { Modal } from 'react-angle-dashboard-components'

export const ModalFooter: React.FC = ({ children }) => {
  return (
    <Modal.Footer className="d-flex justify-content-between align-items-center py-4">
      {children}
    </Modal.Footer>
  )
}
